import React from 'react';
import { Link } from 'react-router-dom';
import { business, services } from '../data/realContent';

const V2Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="v2-footer">
      <div className="v2-container">
        <div className="v2-footer__grid">
          <div className="v2-footer__brand">
            <Link to="/" style={{ display: 'inline-flex', alignItems: 'center', gap: '0.7rem', textDecoration: 'none' }}>
              <img src="/Cosmik Logo/Kolonia_Logo.png" alt="Cosmik Drones logo" style={{ height: 52 }} />
              <span style={{ fontSize: '1.1rem', fontWeight: 800, color: 'var(--v2-text)' }}>Cosmik Drones</span>
            </Link>
            <p style={{ marginTop: '1.2rem', color: 'var(--v2-text-dim)', maxWidth: '38ch', lineHeight: 1.6 }}>
              FAA-certified aerial cinematography and photography based in {business.city}, {business.region}, serving commercial productions, events, and brands across the East Coast.
            </p>
            <p style={{ marginTop: '1rem', fontSize: '0.85rem', color: 'var(--v2-text-mute)' }}>
              FAA Part 107 · {business.chamberMember}
            </p>
          </div>

          <div>
            <h5>Services</h5>
            <ul>
              {services.map((s) => (
                <li key={s.slug}>
                  <Link to={`/services/${s.slug}`}>{s.name}</Link>
                </li>
              ))}
              <li><Link to="/services">All services</Link></li>
            </ul>
          </div>

          <div>
            <h5>Company</h5>
            <ul>
              <li><Link to="/portfolio">Portfolio</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/blog">Blog</Link></li>
              <li><Link to="/contact">Request a Quote</Link></li>
            </ul>
          </div>

          <div>
            <h5>Contact</h5>
            <ul>
              <li><a href={business.phoneHref}>{business.phone}</a></li>
              <li><a href={business.emailHref}>{business.email}</a></li>
              <li>{business.city}, {business.region}</li>
            </ul>
            <div style={{ display: 'flex', gap: '0.8rem', marginTop: '1rem' }}>
              <a href={business.social.instagram} aria-label="Instagram" target="_blank" rel="noreferrer">
                <SocialIcon name="instagram" />
              </a>
              <a href={business.social.linkedin} aria-label="LinkedIn" target="_blank" rel="noreferrer">
                <SocialIcon name="linkedin" />
              </a>
              <a href={business.social.facebook} aria-label="Facebook" target="_blank" rel="noreferrer">
                <SocialIcon name="facebook" />
              </a>
            </div>
          </div>
        </div>

        <div className="v2-footer__bottom">
          <span>© {year} {business.name}. All rights reserved.</span>
          <span>FAA Part 107 certified drone services — Lehigh Valley, Pennsylvania & the East Coast</span>
        </div>
      </div>
    </footer>
  );
};

const SocialIcon = ({ name }) => {
  const props = {
    width: 18, height: 18, viewBox: '0 0 24 24',
    fill: 'none', stroke: 'currentColor', strokeWidth: 1.8,
    style: { color: 'var(--v2-text-dim)' },
  };
  switch (name) {
    case 'instagram':
      return (
        <svg {...props}><rect x="3" y="3" width="18" height="18" rx="5" /><circle cx="12" cy="12" r="4" /><circle cx="17.5" cy="6.5" r="0.8" fill="currentColor" /></svg>
      );
    case 'youtube':
      return (
        <svg {...props}><rect x="2.5" y="6" width="19" height="12" rx="3" /><path d="M11 9.5l4 2.5-4 2.5z" fill="currentColor" stroke="none" /></svg>
      );
    case 'linkedin':
      return (
        <svg {...props}><rect x="3" y="3" width="18" height="18" rx="2" /><path d="M8 10v7M8 7v.01M12 17v-4a2 2 0 0 1 4 0v4M12 17v-7" /></svg>
      );
    case 'facebook':
      return (
        <svg {...props}><path d="M14 8h2V5h-2a3 3 0 0 0-3 3v2H9v3h2v7h3v-7h2.5l.5-3H14V8z" /></svg>
      );
    default:
      return null;
  }
};

export default V2Footer;
